<template>
	<div class="grid-flex-container pa-4" v-if="canView">
		<v-btn-toggle
			v-model="localFilter.Operator"
			tile
			color="primary"
			class="d-flex"
			group
			mandatory
		>
			<span class="align-self-center">Operation:</span>
			<v-btn class="flex-grow-1" :value="1">And</v-btn>
			<v-btn class="flex-grow-1" :value="2">Or</v-btn>
		</v-btn-toggle>
		<v-divider />
		<v-card-text>
			<v-form ref="form">
				<div
					v-for="(filter, index) in localFilter.Filters"
					:key="index"
				>
					<filter-component
						class="d-flex mb-4"
						v-if="filter && !filter.IsDeleted"
						:columns="fields"
						:filter="filter"
						:index="index"
						@onRemoveFilter="removeFilter"
						@filterChanged="onFilterChanged"
					/>
				</div>
			</v-form>
			<v-btn
				color="primary"
				outlined
				@click="addFilter"
				v-if="canAdd && canEdit"
			>
				<v-icon>mdi-plus</v-icon>
				Add filter
			</v-btn>
		</v-card-text>

		<v-divider />
		<v-card-actions>
			<v-spacer />
			<v-btn color="primary" @click="applyFilters" v-if="canAdd"
				>Save</v-btn
			>
		</v-card-actions>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import { ActivityFiltersActions } from '../../../../store/actions';
import { ActivityFiltersGetters } from '../../../../store/getters';
import FilterComponent from '../../../shared/gridViews/FilterComponent.vue';
import permissionsMixin from '../../../../mixins/permissionsMixin';
import { Permissions } from '../../../../enums/permissionsEnum';
export default {
	name: 'ActivityFilter',
	components: { FilterComponent },
	mixins: [permissionsMixin],
	data() {
		return {
			localFilter: { Operator: 1, Filters: [] },
			showDialog: false,
			selectedItem: {},
			search: '',
		};
	},
	computed: {
		...mapGetters({
			filters: [ActivityFiltersGetters.FILTERS],
			fields: [ActivityFiltersGetters.FIELDS],
		}),
		isModified() {
			if (this.filters.Filters.length < 1) return true;
			if (
				JSON.stringify(this.localFilter.Filters) ==
				JSON.stringify(this.filters.Filters)
			)
				return false;
			return true;
		},
		canView() {
			return this.hasPermissions([
				Permissions.Tools.ActivityBuilder.Filters.View,
			]);
		},
		canAdd() {
			return this.hasPermissions([
				Permissions.Tools.ActivityBuilder.Filters.Add,
			]);
		},
		canEdit() {
			return this.hasPermissions([
				Permissions.Tools.ActivityBuilder.Filters.Edit,
			]);
		},
		canDelete() {
			return this.hasPermissions([
				Permissions.Tools.ActivityBuilder.Filters.Delete,
			]);
		},
	},
	destroyed() {
		this.$store.dispatch(ActivityFiltersActions.CLEAR);
	},
	mounted() {
		this.$store
			.dispatch(ActivityFiltersActions.LOAD, this.$route.params.id)
			.then(() => {
				this.localFilter = JSON.parse(JSON.stringify(this.filters));
			});
	},

	methods: {
		addFilter() {
			this.localFilter.Filters.push({
				FieldId: '',
				Operator: null,
				IsDeleted: false,
				Value: '',
			});
		},
		removeFilter(index) {
			this.localFilter.Filters[index].IsDeleted = true;
		},
		applyFilters() {
			if (this.$refs.form.validate()) {
				let notDeletedFilter = this.localFilter.Filters.filter(
					(x) => !x.IsDeleted
				);
				this.localFilter.Filters = notDeletedFilter;
			}
			this.localFilter.ActivityId = this.$route.params.id;
			this.localFilter.LogicalOperator = this.localFilter.Operator;
			this.$store.dispatch(
				ActivityFiltersActions.UPDATE,
				this.localFilter
			);
		},
		onFilterChanged(filter, index) {
			this.localFilter.Filters.splice(index, 1, filter);
		},
	},
};
</script>
